
import Vue from 'vue';
import { Wrapper } from './styles';

export default Vue.extend({
  components: { Wrapper },
  props: {
    title: {
      type: String,
      default: 'Tab',
    },
  },
  data() {
    return {
      isActive: false,
    };
  },
});
